import React, { useCallback, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';
import api from '../../../services/API';
import Footer from '../Footer';
import Header from '../Header';
import './conteudo.css';

export default function Regulamento() {
  const [conteudo, setConteudo] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(false);
  const [naoPublicado, setNaoPublicado] = useState(false);

  const carregar = useCallback(async () => {
    setCarregando(true);
    setErro(false);
    setNaoPublicado(false);
    try {
      const response = await api.get('/api/regulamento');
      if (response && response.response && response.response.status === 404) {
        setConteudo(null);
        setNaoPublicado(true);
        return;
      }
      if (!response || !response.data || !response.data.conteudo) throw new Error();
      setConteudo(response.data.conteudo);
    } catch (error) {
      setConteudo(null);
      if (error.response && error.response.status === 404) setNaoPublicado(true);
      else setErro(true);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  return (
    <>
      <Header auto />
      <Container className="mt-5 mb-5">
        <h5>REGULAMENTO SMART</h5>
        <hr className="hr-loja mt-0" />
        {carregando && <p>Carregando regulamento...</p>}
        {naoPublicado && <p>Regulamento ainda não publicado.</p>}
        {erro && (
          <div role="alert">
            <p>Não foi possível carregar o regulamento.</p>
            <button type="button" className="btn btn-primary" onClick={carregar}>Tentar novamente</button>
          </div>
        )}
        {conteudo && !carregando && (
          <div className="ql-snow">
            <article className="regulamento-conteudo ql-editor" dangerouslySetInnerHTML={{ __html: conteudo }} />
          </div>
        )}
      </Container>
      <Footer />
    </>
  );
}
